import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, 
   Button, Form } from "react-bootstrap";
import PageTitle from "../components/common/PageTitle";
import api from '../api/api'
import { useTranslation } from "react-i18next";
import Html5QrcodePlugin from "../views/Html5QrcodePlugin";

import swal from 'sweetalert';
import { useNavigate } from 'react-router';
import '../css/SensorAdminPages.css';

const AddSensorByAdmin = () => {

  const { t } = useTranslation();
  const navigate=useNavigate()
  const [settingValues, setSettingValues] = useState({})
  const [frequency, setFrequency] = useState('')
  const [dateSetting, setDateSetting] = useState({})
  const [minSetting, setMinSetting] = useState({})
  const [maxSetting, setMaxSetting] = useState({})
  const [simSettings, setSimSettings] = useState({
    simNumber: "",
    simIdentify: ""
  })
  const [resultScan, setResultScan] = useState('')
  const [formValid, setFormValid] = useState(false);
  const [sensorName, setSensorName] = useState('');

  const onNewScanResult = (decodedText, decodedResult) => {
    setResultScan(decodedText)

    // Handle the result here.
  }
  const validateForm = () => {
    // Check if the sensor code, frequency, and date inputs are not empty
    const isCodeValid = resultScan.trim() !== "";
    const isFrequencyValid = frequency.trim() !== "";
    const isNameValid = sensorName.trim() !== "";

    // Update the form validation status
    setFormValid(isCodeValid && isFrequencyValid&& isNameValid);
  };

  useEffect(() => {
    validateForm();
  }, [resultScan, frequency, sensorName]);

  const addNewSensor = () => {
    let data = {
      code: resultScan,
      name: sensorName,
      dataMapping: settingValues,
      frequency: frequency,
      simNumber: simSettings.simNumber,
      simIdentify: simSettings.simIdentify
    }
    if (formValid) {
      api.post('/admin/add-sensor', data)
        .then(response => {
          if (response.data.type === 'success') {
            swal(`${t('sensor_added')}`, {
              icon: "success",
            })
            resetForm()
          }
        }).catch(err => {
          console.error(err)
          swal({
            icon: 'error',
            title: t('Oops...'),
            text: t('error')
          })
        })

    } else {
      swal({
        icon: "error",
        title: t('error'),
        text: t("Please fill in all required fields."),
      });
    }
  }

  const resetForm = () => {
    setTimeout(() => {
      setFrequency("")
      setSensorName("")
      setResultScan('')
      setSimSettings({ simIdentify: "", simNumber: "" })
    }, 1500)
  }

  let niv = ['Mv1', 'Mv2', 'Mv3']

  const onChangeHandlerDate = (value, name, label) => {
    setDateSetting(state => ({ ...state, [`${name}_${label}`]: value }), [])

  }
  const onChangeHandlerMax = (value, name, label) => {
    setMaxSetting(state => ({ ...state, [`${name}_${label}`]: value }), [])

  }
  const onChangeHandlerMin = (value, name, label) => {
    setMinSetting(state => ({ ...state, [`${name}_${label}`]: value }), [])

  }

  useEffect(() => {
    let dataArray = []
    dataArray.push({ date: dateSetting, min: minSetting, max: maxSetting })
    setSettingValues(dataArray)
  }, [dateSetting, minSetting, maxSetting])

  const Items = () => {
    let element = []
    for (let index = 0; index < niv.length; index++) {
      element.push(
        <tbody key={`sensor-depth-row-${niv[index]}`}>
          <tr>
            <td>{niv[index]}</td>
            <td>
              <input
                name={'date'}
                style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                type="date"
                value={dateSetting.index}
                onChange={e => onChangeHandlerDate(e.target.value, niv[index], 'date')}
              />
            </td>
            <td>
              <input
                name={'min'}
                style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                value={minSetting.index}
                onChange={e => onChangeHandlerMin(e.target.value, niv[index], "min")}

              />
            </td>
            <td>
              <input
                name={'max'}
                style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                value={maxSetting.index}
                onChange={e => onChangeHandlerMax(e.target.value, niv[index], "max")}

              />
            </td>
          </tr>
        </tbody>
      )

    }
    return element
  }

  return (
    <Container fluid className="main-content-container sensor-admin-page sensor-add-page px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title={t('add_sensor')}
          subtitle={t('add_sensor')}
          className="text-sm-left"
        />
      </Row>

      <Row>
        <Col lg="12" md="8" sm="12" className="mb-4">
          <Card small className="sensor-admin-card h-100">
            <Card.Header className="border-bottom">
              <div>
                <h6 className="m-0">{t('sensor_setup')}</h6>{" "}
              </div>
              <div className="sensor-admin-actions">
                <Button
                  onClick={addNewSensor}
                  className="mb-2 mr-1 btn btn-success"
                >
                  <i className="fas fa-check me-2" aria-hidden="true" />
                  {t('save')}
                </Button>
                <Button
                  className="mb-2 mr-1 btn btn-danger"
                  onClick={() => navigate('/admin/sensors')}
                >
                  <i className="fas fa-xmark me-2" aria-hidden="true" />
                  {t('cancel')}
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="pt-0">
              <Row
                style={{
                  marginTop: "20px",
                  flexWrap: "wrap",
                  gap:"10px"
                }}
              >
                <Col lg="8" sm="12" md="6">
                  <Form className="sensor-admin-form">
                    <Row form className='gap-4'>
                      <Col lg="5" md="12" sm="12" className="form-group">
                        <p style={{ margin: "0px" }}>{t('sensor_code')}</p>
                        <Form.Control
                          placeholder={t('sensor_code')}
                          value={resultScan}
                          onChange={e => setResultScan(e.target.value)}
                          required

                        />
                      </Col>
                      <Col lg="6" md="12" sm="12" className="form-group">
                        <p style={{ margin: "0px" }}>{t('Frequency')}</p>
                        <Form.Control
                          placeholder={t('Frequency')}
                          value={frequency}
                          onChange={e => { setFrequency(e.target.value) }}
                          required
                        />
                      </Col>
                    </Row>
                    <Row className='gap-4'>
                      <Col lg="5" md="12" sm="12" className="form-group">
                        <p style={{ margin: "0px" }}>{t('SIM card number')} (MSISDN)</p>
                        <Form.Control
                          placeholder={t('SIM card number')}
                          value={simSettings.simNumber}
                          onChange={e => setSimSettings({ ...simSettings, simNumber: e.target.value })}
                          required
                        />
                      </Col>
                      <Col lg="6" md="12" sm="12" className="form-group">
                        <p style={{ margin: "0px" }}>{t('SIM Card identifier')} (ICCID)</p>
                        <Form.Control
                          placeholder={t('SIM Card identifier')}
                          value={simSettings.simIdentify}
                          onChange={e => setSimSettings({ ...simSettings, simIdentify: e.target.value })}
                          required
                        />
                      </Col>
                    </Row>
                    <Row form className='gap-4'>
                      <Col lg="5" md="12" sm="12" className="form-group">
                        <p style={{ margin: "0px" }}>{t('sensor_Name')}</p>
                        <Form.Control
                          placeholder={t('sensor_Name')}
                          value={sensorName}
                          onChange={e => setSensorName(e.target.value)}
                          required

                        />
                      </Col>
                      </Row>
                    <Row className="sensor-admin-table-wrap">
                      <table className="table text-center">
                        <thead className="bg-light">
                          <tr>
                            <th scope="col" className="border-0">{t('niveau')}</th>
                            <th scope="col" className="border-0">{t('Date')}</th>
                            <th scope="col" className="border-0">{t('Min')} (%)</th>
                            <th scope="col" className="border-0">{t('Max')} (%)</th>
                          </tr>
                        </thead>

                        {Items()}

                      </table>

                    </Row>

                  </Form>
                </Col>
                <Col lg="3" md="12" sm="12" className="mb-4">
                  <div className="sensor-qr-panel">
                    <h3>{t('scan_qrcode_sensor')}</h3>
                    <Html5QrcodePlugin
                      fps={10}
                      qrbox={250}
                      disableFlip={true}
                      rememberLastUsedCamera={false}
                      qrCodeSuccessCallback={onNewScanResult}

                    />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default AddSensorByAdmin
